import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n\n  fragment Linkable on _Linkable {\n    ...ExternalLink\n    ...DocumentLink\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  fragment DocumentLink on _Document {\n    __typename\n    _meta {\n      type\n      id\n      uid\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fragment ExternalLink on _ExternalLink {\n    _linkType\n    __typename\n    url\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from "graphql-tag";
export var externalLinkFragment = gql(_templateObject());
export var documentLinkFragment = gql(_templateObject2());
export var linkableFragment = gql(_templateObject3(), externalLinkFragment, documentLinkFragment);